export const environment = {
    production: false,
    //baseUrl: 'http://localhost:3000/api'
    baseUrl: 'https://server.rasayi-staging.kalpayfinancials.com/api'
};